var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "80px",
    viewBox: "0 0 126 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Istrazivacko-razvojni-institut-za-ve\u0161tacku-inteligenciju-srbije-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    transform: "translate(-183, -244)",
    fill: "#09A4AC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-183.8656, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Istrazivacko-razvojni-institut-za-ve\\u0161tacku-inteligenciju-srbije-logo",
    transform: "translate(366.8656, 244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 22,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 105.133758,
    y: 0,
    width: 20.866242,
    height: 80
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "43.3375796 -6.64746036e-14 64.1855952 -6.64746036e-14 76.5215967 33.2143147 93.8980892 80 73.0500736 80"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.937fad23b6c9f2aeaeb48b7cfb58e182.svg";
export { ForwardRef as ReactComponent };